import { EMPTY_FIELD } from 'constants/emptyField';

import { usePermissions } from 'hooks/usePermissions';
import { RecordContextProvider, TextField } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { Button } from 'shared/mui/Buttons';
import { CardActionsButtons } from 'shared/mui/Card';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { WhiteIpAddressesTooltip } from 'shared/mui/Tooltip/WhiteIpAddressesTooltip/WhiteIpAddressesTooltip';
import { Typography } from 'shared/mui/Typography';
import { NumberField } from 'shared/react-admin/Fields';
import { Permission } from 'types/embedded/permission';
import { ProviderWhiteIpAddress } from 'types/embedded/provider';

export type Props = {
  record?: ProviderWhiteIpAddress;
  onClose: () => void;
  onEdit: () => void;
  onDelete: () => void;
} & DialogProps;

export const ProvidersShowWhiteIpAddressesShowDialog: React.FC<Props> = ({
  open,
  record,
  onClose,
  onDelete,
  onEdit,
}) => {
  const { hasResourcePermissions } = usePermissions();

  return (
    <Dialog fullWidth maxWidth="sm" onClose={onClose} open={open}>
      <CardHeader
        appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
        title="Просмотр белого IP"
        titleSize="smallBold"
      />
      <Box m={3} mb={0}>
        <RecordContextProvider value={record}>
          <CardTable tableBodyProps={{ sx: { '& td': { width: '126px' } } }}>
            <TableRowWrapper label="ID">
              <TextField source="originId" />
            </TableRowWrapper>
            <TableRowWrapper label="IP">
              <TextField source="ip" />
            </TableRowWrapper>
            <TableRowWrapper
              label={
                <Box alignItems="center" display="flex" gap="8px">
                  <Typography fontSize="14px" fontWeight={500}>
                    Маска
                  </Typography>
                  <WhiteIpAddressesTooltip />
                </Box>
              }
            >
              <NumberField emptyText={EMPTY_FIELD} label="Маска" source="mask" />
            </TableRowWrapper>
            <TableRowWrapper label="Комментарий">
              <TextField source="comment" />
            </TableRowWrapper>
          </CardTable>
        </RecordContextProvider>
      </Box>
      <CardActionsButtons
        rightActionsSlot={[
          hasResourcePermissions('provider_white_ip_addresses', [
            Permission.Full,
            Permission.Delete,
          ]) && (
            <Button
              color="error"
              key="delete-button"
              label="Удалить"
              onClick={onDelete}
              variant="outlined"
            />
          ),
          hasResourcePermissions('provider_white_ip_addresses', [
            Permission.Full,
            Permission.Update,
          ]) && (
            <Button key="edit-button" label="Редактировать" onClick={onEdit} variant="contained" />
          ),
        ]}
      />
    </Dialog>
  );
};
